import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductDetailLayout from './ProductDetailLayout';
import { getProduct } from '../../product-catalog/productPresentation';

const features = ['monitoring', 'production', 'notification', 'remote'];

const managementFeatures = ['issue', 'shift', 'permission'];

export default function HiCPSIntroPage() {
  const { t } = useTranslation('app');

  const copy = key => t('productIntro.hicps.' + key);

  return (
    <ProductDetailLayout product={getProduct('hi-cps')}>
      <section
        className="hicps-overview-section"
        aria-labelledby="hicps-overview-title"
      >
        <div className="hicps-container">
          <h2 id="hicps-overview-title">{copy('about.title')}</h2>
          <div className="hicps-overview-layout">
            <figure className="hicps-connected-visual hicps-connected-visual--overview">
              <img
                src="/ProductCatalog/hi-cps-connected-equipment.png"
                alt={copy('about.description2')}
                width="1536"
                height="1024"
                loading="eager"
                decoding="async"
              />
            </figure>

            <div className="hicps-core-features hicps-core-features--side">
              {features.map((feature, index) => (
                <article className="hicps-core-feature" key={feature}>
                  <span className="hicps-core-number" aria-hidden="true">
                    {index + 1}.
                  </span>

                  <div>
                    <h3>{copy(`overview.${feature}.title`)}</h3>
                    <p>{copy(`overview.${feature}.description`)}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="hicps-operations-summary">
            <h2>{copy('management.title')}</h2>

            <div className="hicps-management-layout">
              <figure className="hicps-connected-visual hicps-connected-visual--management">
                <img
                  src="/ProductCatalog/hi-cps-team-management-v2.png"
                  alt={[
                    copy('overview.monitoring.title'),
                    copy('management.items.shift.title'),
                    copy('management.items.permission.title'),
                  ].join(' / ')}
                  width="2172"
                  height="724"
                  loading="lazy"
                  decoding="async"
                />
              </figure>

              <ul className="hicps-core-features hicps-core-features--side">
                {managementFeatures.map((feature, index) => (
                  <li className="hicps-core-feature" key={feature}>
                    <span className="hicps-core-number" aria-hidden="true">
                       {features.length + index + 1}.
                    </span>

                    <div>
                      <h4>{copy(`management.items.${feature}.title`)}</h4>
                      <p>{copy(`management.items.${feature}.description`)}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section
        className="hicps-support-section"
        aria-labelledby="hicps-compatibility-title"
      >
        <div className="hicps-container">
          <div className="hicps-support-card">
            <div className="hicps-support-title">
              <h2 id="hicps-compatibility-title">{copy('support.title')}</h2>
            </div>

            <div className="hicps-support-description">
              <p>{copy('support.description1')}</p>
              <p>{copy('support.description2')}</p>

              <div className="hicps-notice">
                <p>{copy('support.notice1')}</p>
                <p>{copy('support.notice2')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ProductDetailLayout>
  );
}
